import { IPaymentDistribution } from "../Interface";
import { Payment } from "./Payment";
import {Apportionment} from './Apportionment'

export const InitialState:IPaymentDistribution = {
    payment:Payment,
    apportionments:Apportionment
}